import { Button, Divider, Modal } from "@mantine/core";
import React, { useRef } from "react";
import { sectorApi } from "../../apis";
import { ISector } from "../../interfaces/ISector";
import { PageLayout } from "../layout";
import { ColumnType, ITableRef, Table } from "../table";
import { Tag } from "../tags";
import RenderText from "../ui/render-text";
import { BasicSectorForm } from "./form";

function BasicSectorList(): React.JSX.Element {
  const ref = useRef<ITableRef>(null);
  const breadcrumb = useBreadcrumb();
  const [action, setAction] = React.useState<string[]>([]);

  const columns = useHeader();

  const onCancel = () => {
    setAction([]);
  };

  const reload = () => {
    ref.current?.reload();
  };

  return (
    <>
      <PageLayout
        title="Үндсэн ангилал жагсаалт"
        subTitle="Dehub бизнес платформын эдийн засгийн үндсэн ангиллын бүртгэл"
        breadcrumb={breadcrumb}
        extra={[
          <Button onClick={() => setAction(["BASIC"])} key={1}>
            Нэмэх
          </Button>,
        ]}>
        <Divider mb={5} />
        <Table
          ref={ref}
          name="partner-management-user-basic-sector-data.list"
          columns={columns}
          filters={{ level: "1", query: "" }}
          loadData={(data) => sectorApi.list(data!)}
        />
      </PageLayout>

      <Modal opened={action[0] === "BASIC"} onClose={() => onCancel()} withCloseButton={false} size="lg" centered>
        <BasicSectorForm reload={reload} onCancel={onCancel} />
      </Modal>
    </>
  );
}

export { BasicSectorList };

const useHeader = (): ColumnType<ISector>[] => [
  {
    title: "#",
    width: "30px",
    render: (_r, index) => <RenderText text={index + 1} />,
  },
  {
    title: "Нэр",
    sorter: true,
    dataIndex: "name",
    render: (record) => <RenderText text={record?.name ?? "-"} />,
  },
  {
    title: "Код",
    sorter: true,
    dataIndex: "refCode",
    render: (record) => <RenderText text={record?.refCode ?? "-"} />,
  },
  {
    title: "Нээлттэй",
    sorter: true,
    dataIndex: "refCode",
    render: (record) => <Tag name={record.isPublic ? "Тийм" : "Үгүй"} color={record.isPublic ? "green" : "red"} />,
  },
];

const useBreadcrumb = () => [
  {
    to: "/",
    label: "Эхлэл",
  },
  {
    label: "Секторын лавлах жагсаалт",
    to: "/partner-management/sector",
  },
  {
    label: "Үндсэн ангиллын жагсаалт",
  },
];
